'use client'
import Link, { LinkProps } from 'next/link'
import { BackIcon } from '@/root/ui/shared'
import { useGetTranslations } from '@/root/shared-hooks'

type GoBackButtonProps = LinkProps

export const GoBackButton = ({ href, ...rest }: GoBackButtonProps) => {
  const { getTranslation } = useGetTranslations()

  return (
    <Link
      href={href}
      data-testid="go-to-prev"
      className="border-neutral-medium-light flex h-20 w-1/2 max-w-64 items-center justify-between rounded-2xl border px-4"
      {...rest}
    >
      <div className="size-6">
        <BackIcon color="neutral-medium-light" />
      </div>
      <div className="flex size-max flex-col flex-wrap items-end justify-around">
        <div className="text-neutral-medium-light xxs:text-2xl/7 text-right text-xl font-bold uppercase">
          {getTranslation('backButton')}
        </div>
        <div className="text-neutral-medium-light text-right text-sm font-semibold">
          {getTranslation('goBackChangeRouteSubtitle')}
        </div>
      </div>
    </Link>
  )
}
